import React from "react";
import type { Message } from '@dev-streetbeat/chat';
import { formatDateChatUserMessage } from "utils/dateUtils";
import styles from "./chatMessage.module.scss";

type Props = {
  message: Message;
};

export const ChatUserMessage: React.FC<Props> = ({ message }) => {
  const formattedDate = formatDateChatUserMessage(message.created_at);

  const renderContent = (contentItem: any, index: number) => {
    if (contentItem.type === 'text' && contentItem.text?.value) {
      return (
        <div key={index} className="mt-2 flex justify-end">
          <div className={styles.chatUserMessage}>
            {contentItem.text.value}
            <div className={styles.chatUserMessageTime}>{formattedDate}</div>
          </div>
        </div>
      );
    } else if (contentItem.type === 'document' && contentItem.source) {
      const { media_type, data } = contentItem.source;
      
      if (media_type.startsWith('image/')) {
        return (
          <div key={index} className="mt-2 flex justify-end">
            <div className={styles.chatUserMessage}>
              <img 
                src={`data:${media_type};base64,${data}`}
                alt="User uploaded content"
                className="max-w-full rounded"
                style={{ maxHeight: '300px' }}
              />
              <div className={styles.chatUserMessageTime}>{formattedDate}</div>
            </div>
          </div>
        );
      } else if (media_type === 'application/pdf') {
        return (
          <div key={index} className="mt-2 flex justify-end">
            <div className={styles.chatUserMessage}>
              <div className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <a 
                  href={`data:${media_type};base64,${data}`}
                  download={`document-${index}.pdf`}
                  className="text-blue-600 hover:underline"
                >
                  Download PDF
                </a>
              </div>
              <div className={styles.chatUserMessageTime}>{formattedDate}</div>
            </div>
          </div>
        );
      }
    }
    
    return null;
  };

  return (
    <>
      {message?.content?.map((contentItem, index) => renderContent(contentItem, index))}
    </>
  );
};
